// Saved Workouts list params the single-workout editor must carry so Back
// returns to the same folder. The editor used to hardcode status=draft (copied
// from the store's draft list). Saved workouts have no draft filter, so status
// is forwarded only when the list URL actually had it.

export const SAVED_WORKOUT_LIST_QUERY_KEYS = [
  "owner",
  "tabView",
  "templateView",
  "folderId",
  "status",
  "sort",
  "page",
  "workoutSearch",
];

const presentValue = (value) => {
  if (typeof value === "number" && Number.isFinite(value)) return String(value);
  if (typeof value === "string" && value.trim() !== "") return value;
  return null;
};

/** Copy list params off the Saved Workouts URL (or the editor query that carried them). */
export const pickSavedWorkoutListQuery = (query = {}) => {
  const picked = {};
  for (const key of SAVED_WORKOUT_LIST_QUERY_KEYS) {
    const value = presentValue(query[key]);
    if (value !== null) picked[key] = value;
  }
  return picked;
};

/**
 * Query for `/coaching-portal/all-templates` when leaving the single-workout
 * editor. Missing tab params fall back to the Saved Workouts root. `folderId`
 * and `status` are included only when the edit route carried them.
 */
export const savedWorkoutListReturnQuery = (query = {}) => {
  const carried = pickSavedWorkoutListQuery(query);
  return {
    owner: carried.owner || "coach",
    tabView: carried.tabView || "single-workouts-tab",
    templateView: carried.templateView || "single-workouts",
    ...(carried.folderId ? { folderId: carried.folderId } : {}),
    ...(carried.status ? { status: carried.status } : {}),
    ...(carried.sort ? { sort: carried.sort } : {}),
    ...(carried.page ? { page: carried.page } : {}),
    ...(carried.workoutSearch ? { workoutSearch: carried.workoutSearch } : {}),
  };
};
